import { storeToRefs } from 'pinia';
import useContent from '../stores/useContent';
import findAncestorIds from './findAncestorIds';
import evaluateCondition from './evaluateCondition';

/**
 * Checks if the given ID is hidden.
 * @param id - The ID to check.
 * @returns True if the ID is hidden, false otherwise.
 */
export default function isHidden(id) {
  const { compiled } = storeToRefs(useContent());
  return Boolean(compiled.value.hidden?.[id]);
}

/**
 * Checks if any ancestor of the given ID is hidden in the hierarchy, optionally including the ID itself.
 * @param startId - The ID to start checking from.
 * @param includeStartId - Whether to include the start ID in the check.
 * @returns True if any ancestor of the start ID is hidden in the hierarchy, false otherwise.
 */
export function isHiddenInHierarchy(startId, includeStartId = true) {
  const { compiled } = storeToRefs(useContent());
  if (!compiled.value.hidden) return false;

  const hierarchyIDs = findAncestorIds(compiled.value.pages, startId) || [];
  if (hierarchyIDs?.length === 0) return false;

  if (!includeStartId) hierarchyIDs.pop();

  const isHierarchyHidden = evaluateCondition(
    { any: 1, of: hierarchyIDs },
    compiled.value.hidden
  );
  return isHierarchyHidden;
}
